import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function LogoIcon(props) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 50 56"
      width={props.width || 20}
      height={props.height || 20}
      fill={props.fill || 'currentColor'}
    >
      <path
        d="m18.667 2.2857c-0.8416 0-1.5239 0.68223-1.5239 1.5238 0 0.84158 0.6823 1.5238 1.5239 1.5238h0.8249c0.5528 3.2581 0.5535 5.1107 2e-3 8.3654-1.8514-0.8387-4.0883-1.5016-6.5412-1.5082-7.2812-0.0196-12.952 5.8894-12.952 14.476 0 13.676 11.086 24.762 24.762 29.333 13.676-4.5714 24.762-15.658 24.762-29.333 0-8.5078-5.3592-14.476-12.952-14.476-2.4447 0-4.6845 0.666-6.541 1.5095-0.5516-3.2555-0.551-5.1082 0.0018-8.3667h0.8249c0.8416 0 1.5238-0.68223 1.5238-1.5238 0-0.84157-0.6822-1.5238-1.5238-1.5238h-12.19z"
        clipRule="evenodd"
        fill="#DFE6F3"
        fillRule="evenodd"
      />
      <path
        d="m3.8095 27.048c9e-5 12.19 9.3807 20.571 20.952 20.571 11.572 0 20.952-9.3807 20.952-20.19 0-7.1302-4.2397-11.508-9.3332-11.526-8.8099-0.0317-15.576 12.478-26.857 12.478-3.2381 0-5.2648-2.4762-5.2648-4.7619-0.19047 0.5715-0.44952 2.2857-0.44952 3.4286z"
        fill="url(#b)"
      />
      <path
        d="m45.714 27.147c2e-4 -0.0331 2e-4 -0.0664 2e-4 -0.0996 0-1.1429-0.259-2.8571-0.4495-3.4286 0 2.2857-2.0266 4.7619-5.2647 4.7619-5.9822 0-10.695-3.5177-15.116-6.8177-3.9161-2.9232-7.6034-5.6756-11.742-5.6607-5.0935 0.0183-9.3333 4.3959-9.3333 11.526v0.0095c-1.4e-4 0.0293-2.1e-4 0.0586-2.1e-4 0.0879 0 10.81 9.3807 20.19 20.952 24.762 7.2508-2.8644 13.641-7.5238 17.403-13.416 1.9675-2.854 3.2157-6.3006 3.4916-10.179 0.0383-0.5105 0.0578-1.026 0.0578-1.5462zm-1e-3 0.1446c7e-4 -0.0482 1e-3 -0.0964 1e-3 -0.1446-2e-4 0.0483-5e-4 0.0965-1e-3 0.1446z"
        clipRule="evenodd"
        fill="url(#a)"
        fillRule="evenodd"
      />
      <path
        d="M19.8056 2.28571C19.6081 1.0885 20.5317 0 21.7451 0H27.7786C28.992 0 29.9156 1.0885 29.7181 2.28571H19.8056Z"
        fill="#E64A5B"
      />
      <defs>
        <linearGradient
          id="b"
          x1="33.524"
          x2="34.667"
          y1="26.095"
          y2="10.476"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E33863" offset="0" />
          <stop stopColor="#E65057" offset=".94598" />
        </linearGradient>
        <linearGradient
          id="a"
          x1="10.857"
          x2="30.476"
          y1="16"
          y2="47.81"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E96150" offset="0" />
          <stop stopColor="#E33863" offset="1" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
}



// WEBPACK FOOTER //
// ./src/icons/LogoIcon.jsx